import { defineMessages } from 'react-intl';

/**
 * Shared labels for protocol-related forms and modals so identical English
 * strings are not extracted as separate translation entries.
 */
export const sharedActionMessages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    id: '6SnMCLmEYD',
    description: 'Button label to close a protocol form or dialog without saving changes',
  },
  save: {
    defaultMessage: 'Save',
    id: '8lnsxbJDGS',
    description: 'Primary button label to save protocol changes from a form or modal',
  },
  protocolName: {
    defaultMessage: 'Protocol name',
    id: 'WphZBfzHVm',
    description:
      'Label for the protocol title or name input when creating, editing, or adding a protocol',
  },
});
